/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
import Theme from '@nmx/template/dist/componentLibrary/Theme';
// native components
import AdvisorConnectModule from './components/advisorConnectModule';
import HeroSection from './components/heroSection';
import IntroSection from './components/introSection';
import Metadata from './components/metadata';
import FinancialPlanningSection1 from './components/financialPlanningSection1';
import FinancialPlanningSection2 from './components/financialPlanningSection2';
// images for prefetch
import highResDesktopImage from './components/heroSection/images/account-protection-hero-desktop.webp';
import highResMobileImage from './components/heroSection/images/account-protection-hero-mobile.webp';
// dislaimer footnotes
import { RankingNmInvestmentsServices } from '../../../utils/disclaimerFootnotes/disclaimerFootnotes';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps } = useRouteData();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      disableDisclaimerTopBorder
      config={config}
      useReCaptcha={false}
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Investments',
          linkUrl: '/investments/',
          linkAriaLabel: 'Northwestern Mutual Investments',
        },
        {
          pageName: 'Investment Account Protection',
          linkUrl: '/investments/protection',
          linkAriaLabel: 'Northwestern Mutual Investment Account Protection',
        },
      ]}
      customDisclaimers={[
        <>
          <sup>1</sup>&nbsp;Combined client assets of Northwestern Mutual Investment Services, LLC (NMIS) and Northwestern Mutual Wealth Management Company (NMWMC) as of the end of May 2023. The advisory programs offered by NMWMC are in conjunction with brokerage services from NMWMC&#39;s affiliate, NMIS. NMIS is a wholly owned subsidiary of Northwestern Mutual.
        </>,
        <>
          {RankingNmInvestmentsServices(2)}
        </>,
      ]}>
      <Head>
        {/* prefetch expensive images */}
        <link rel='preload' href={highResMobileImage} as='image' media={`(max-width: ${Theme.breakpoints.values.medium}px)`} />
        <link rel='preload' href={highResDesktopImage} as='image' media={`(min-width: ${Theme.breakpoints.values.medium + 1}px)`} />
      </Head>

      {/* METADATA */}
      <Metadata image={highResDesktopImage}/>

      <HeroSection />

      <IntroSection />

      <FinancialPlanningSection1 />

      <FinancialPlanningSection2 />

      <AdvisorConnectModule />

    </Page>
  );
};
